import { useContext } from 'react';

import {
  defaultViewerProfileContextValue,
  ViewerProfileContext,
  type ViewerProfileContextValue,
} from './ViewerProfileContext';

const isProduction = import.meta.env.PROD;

export const useViewerProfile = (): ViewerProfileContextValue => {
  const context = useContext(ViewerProfileContext);

  if (!isProduction && context === defaultViewerProfileContextValue) {
    console.warn('useViewerProfile used outside ViewerProfileProvider');
  }

  return context;
};
